/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Claim_Vekn_DescriptionInputs */



/**
* | output |
* | --- |
* | "Enter your VEKN ID. It must exist and not belong to someone else." |
*
* @param {Profile_Claim_Vekn_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_claim_vekn_description = /** @type {((inputs?: Profile_Claim_Vekn_DescriptionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Claim_Vekn_DescriptionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Saisissez votre ID VEKN. Il doit exister et ne pas appartenir à quelqu'un d'autre.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Introduzca su ID VEKN. Debe existir y no pertenecer a otra persona.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Digite seu ID VEKN. Ele precisa existir e não pertencer a outra pessoa.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci il tuo ID VEKN. Deve esistere e non appartenere a qualcun altro.")
	return /** @type {LocalizedString} */ ("Enter your VEKN ID. It must exist and not belong to someone else.")
});